module.exports = __webpack_public_path__ + "assets/add-on-illustrations-adapter-02.cabf14c4.svg";